/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AssistantApiErrorResponse } from '../model';
// @ts-ignore
import type { AssistantConversation } from '../model';
// @ts-ignore
import type { AssistantConversationMessage } from '../model';
// @ts-ignore
import type { AssistantConversationPage } from '../model';
// @ts-ignore
import type { CreateAISystemsAcceptance } from '../model';
// @ts-ignore
import type { CreateAISystemsAction } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { RenameConversationRequest } from '../model';
// @ts-ignore
import type { ScopeType } from '../model';
// @ts-ignore
import type { SendMessageRequest } from '../model';
// @ts-ignore
import type { StartConversationRequest } from '../model';
// @ts-ignore
import type { StreamAssistantConversation200Response } from '../model';
// @ts-ignore
import type { TurnAccepted } from '../model';
// @ts-ignore
import type { TurnOptions } from '../model';
/**
 * AssistantConversationsApi - axios parameter creator
 */
export const AssistantConversationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Run what Scout proposed with the chosen items, in one transaction. The first decision wins: an accepted action answers with its stored result, a dismissed or revised one with `action_already_decided`.
         * @summary Accept Assistant Action
         * @param {string} conversationId 
         * @param {string} actionId 
         * @param {CreateAISystemsAcceptance} createAISystemsAcceptance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptAssistantAction: async (conversationId: string, actionId: string, createAISystemsAcceptance: CreateAISystemsAcceptance, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('acceptAssistantAction', 'conversationId', conversationId)
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('acceptAssistantAction', 'actionId', actionId)
            // verify required parameter 'createAISystemsAcceptance' is not null or undefined
            assertParamExists('acceptAssistantAction', 'createAISystemsAcceptance', createAISystemsAcceptance)
            const localVarPath = `/modulos-assistant/conversations/{conversation_id}/actions/{action_id}/accept`
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)))
                .replace('{action_id}', encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAISystemsAcceptance, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one of the user\'s conversations; refused while it is answering.
         * @summary Delete Assistant Conversation
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssistantConversation: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('deleteAssistantConversation', 'conversationId', conversationId)
            const localVarPath = `/modulos-assistant/conversations/{conversation_id}`
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Decline what Scout proposed. A dismissed action answers as it is, an accepted or revised one with `action_already_decided`.
         * @summary Dismiss Assistant Action
         * @param {string} conversationId 
         * @param {string} actionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissAssistantAction: async (conversationId: string, actionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('dismissAssistantAction', 'conversationId', conversationId)
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('dismissAssistantAction', 'actionId', actionId)
            const localVarPath = `/modulos-assistant/conversations/{conversation_id}/actions/{action_id}/dismiss`
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)))
                .replace('{action_id}', encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Assistant Conversation
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssistantConversation: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getAssistantConversation', 'conversationId', conversationId)
            const localVarPath = `/modulos-assistant/conversations/{conversation_id}`
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inputs the next question can be sent with, preselected from the last question.
         * @summary Get Assistant Conversation Turn Options
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssistantConversationTurnOptions: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getAssistantConversationTurnOptions', 'conversationId', conversationId)
            const localVarPath = `/modulos-assistant/conversations/{conversation_id}/turn-options`
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inputs a new conversation in this scope can be started with.
         * @summary Get Assistant Turn Options
         * @param {ScopeType} scopeType 
         * @param {string | null} [aiSystemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssistantTurnOptions: async (scopeType: ScopeType, aiSystemId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scopeType' is not null or undefined
            assertParamExists('getAssistantTurnOptions', 'scopeType', scopeType)
            const localVarPath = `/modulos-assistant/turn-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scopeType !== undefined) {
                localVarQueryParameter['scope_type'] = scopeType;
            }

            if (aiSystemId !== undefined) {
                localVarQueryParameter['ai_system_id'] = aiSystemId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Assistant Conversation Messages
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssistantConversationMessages: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('listAssistantConversationMessages', 'conversationId', conversationId)
            const localVarPath = `/modulos-assistant/conversations/{conversation_id}/messages`
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The current user\'s conversations across scopes, most recently active first; `title` searches them.
         * @summary List Assistant Conversations
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {ScopeType | null} [scopeType] 
         * @param {string | null} [aiSystemId] 
         * @param {string | null} [title] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssistantConversations: async (page?: number, size?: number, scopeType?: ScopeType | null, aiSystemId?: string | null, title?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/modulos-assistant/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (scopeType !== undefined) {
                localVarQueryParameter['scope_type'] = scopeType;
            }

            if (aiSystemId !== undefined) {
                localVarQueryParameter['ai_system_id'] = aiSystemId;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rename Assistant Conversation
         * @param {string} conversationId 
         * @param {RenameConversationRequest} renameConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameAssistantConversation: async (conversationId: string, renameConversationRequest: RenameConversationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('renameAssistantConversation', 'conversationId', conversationId)
            // verify required parameter 'renameConversationRequest' is not null or undefined
            assertParamExists('renameAssistantConversation', 'renameConversationRequest', renameConversationRequest)
            const localVarPath = `/modulos-assistant/conversations/{conversation_id}`
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameConversationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Run the last failed question again with the inputs it was sent with.
         * @summary Retry Assistant Turn
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryAssistantTurn: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('retryAssistantTurn', 'conversationId', conversationId)
            const localVarPath = `/modulos-assistant/conversations/{conversation_id}/retry`
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send Assistant Message
         * @param {string} conversationId 
         * @param {SendMessageRequest} sendMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAssistantMessage: async (conversationId: string, sendMessageRequest: SendMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('sendAssistantMessage', 'conversationId', conversationId)
            // verify required parameter 'sendMessageRequest' is not null or undefined
            assertParamExists('sendAssistantMessage', 'sendMessageRequest', sendMessageRequest)
            const localVarPath = `/modulos-assistant/conversations/{conversation_id}/messages`
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a conversation in a scope together with its first question.
         * @summary Start Assistant Conversation
         * @param {StartConversationRequest} startConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAssistantConversation: async (startConversationRequest: StartConversationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startConversationRequest' is not null or undefined
            assertParamExists('startAssistantConversation', 'startConversationRequest', startConversationRequest)
            const localVarPath = `/modulos-assistant/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startConversationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Live events of a conversation. Answers carry their message id as SSE id; reconnect with `Last-Event-ID`.
         * @summary Stream Assistant Conversation
         * @param {string} conversationId 
         * @param {string | null} [lastEventID] Replay the answers after this message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        streamAssistantConversation: async (conversationId: string, lastEventID?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('streamAssistantConversation', 'conversationId', conversationId)
            const localVarPath = `/modulos-assistant/conversations/{conversation_id}/stream`
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/event-stream,application/json';

            if (lastEventID != null) {
                localVarHeaderParameter['Last-Event-ID'] = String(lastEventID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssistantConversationsApi - functional programming interface
 */
export const AssistantConversationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssistantConversationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Run what Scout proposed with the chosen items, in one transaction. The first decision wins: an accepted action answers with its stored result, a dismissed or revised one with `action_already_decided`.
         * @summary Accept Assistant Action
         * @param {string} conversationId 
         * @param {string} actionId 
         * @param {CreateAISystemsAcceptance} createAISystemsAcceptance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptAssistantAction(conversationId: string, actionId: string, createAISystemsAcceptance: CreateAISystemsAcceptance, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateAISystemsAction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptAssistantAction(conversationId, actionId, createAISystemsAcceptance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantConversationsApi.acceptAssistantAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one of the user\'s conversations; refused while it is answering.
         * @summary Delete Assistant Conversation
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAssistantConversation(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAssistantConversation(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantConversationsApi.deleteAssistantConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Decline what Scout proposed. A dismissed action answers as it is, an accepted or revised one with `action_already_decided`.
         * @summary Dismiss Assistant Action
         * @param {string} conversationId 
         * @param {string} actionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dismissAssistantAction(conversationId: string, actionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateAISystemsAction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dismissAssistantAction(conversationId, actionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantConversationsApi.dismissAssistantAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Assistant Conversation
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssistantConversation(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssistantConversation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssistantConversation(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantConversationsApi.getAssistantConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Inputs the next question can be sent with, preselected from the last question.
         * @summary Get Assistant Conversation Turn Options
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssistantConversationTurnOptions(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TurnOptions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssistantConversationTurnOptions(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantConversationsApi.getAssistantConversationTurnOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Inputs a new conversation in this scope can be started with.
         * @summary Get Assistant Turn Options
         * @param {ScopeType} scopeType 
         * @param {string | null} [aiSystemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssistantTurnOptions(scopeType: ScopeType, aiSystemId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TurnOptions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssistantTurnOptions(scopeType, aiSystemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantConversationsApi.getAssistantTurnOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Assistant Conversation Messages
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAssistantConversationMessages(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssistantConversationMessage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAssistantConversationMessages(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantConversationsApi.listAssistantConversationMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The current user\'s conversations across scopes, most recently active first; `title` searches them.
         * @summary List Assistant Conversations
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {ScopeType | null} [scopeType] 
         * @param {string | null} [aiSystemId] 
         * @param {string | null} [title] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAssistantConversations(page?: number, size?: number, scopeType?: ScopeType | null, aiSystemId?: string | null, title?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssistantConversationPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAssistantConversations(page, size, scopeType, aiSystemId, title, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantConversationsApi.listAssistantConversations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Rename Assistant Conversation
         * @param {string} conversationId 
         * @param {RenameConversationRequest} renameConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameAssistantConversation(conversationId: string, renameConversationRequest: RenameConversationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssistantConversation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameAssistantConversation(conversationId, renameConversationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantConversationsApi.renameAssistantConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Run the last failed question again with the inputs it was sent with.
         * @summary Retry Assistant Turn
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryAssistantTurn(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TurnAccepted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryAssistantTurn(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantConversationsApi.retryAssistantTurn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send Assistant Message
         * @param {string} conversationId 
         * @param {SendMessageRequest} sendMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendAssistantMessage(conversationId: string, sendMessageRequest: SendMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TurnAccepted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendAssistantMessage(conversationId, sendMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantConversationsApi.sendAssistantMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a conversation in a scope together with its first question.
         * @summary Start Assistant Conversation
         * @param {StartConversationRequest} startConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startAssistantConversation(startConversationRequest: StartConversationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TurnAccepted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startAssistantConversation(startConversationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantConversationsApi.startAssistantConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Live events of a conversation. Answers carry their message id as SSE id; reconnect with `Last-Event-ID`.
         * @summary Stream Assistant Conversation
         * @param {string} conversationId 
         * @param {string | null} [lastEventID] Replay the answers after this message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async streamAssistantConversation(conversationId: string, lastEventID?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StreamAssistantConversation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.streamAssistantConversation(conversationId, lastEventID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantConversationsApi.streamAssistantConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssistantConversationsApi - factory interface
 */
export const AssistantConversationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssistantConversationsApiFp(configuration)
    return {
        /**
         * Run what Scout proposed with the chosen items, in one transaction. The first decision wins: an accepted action answers with its stored result, a dismissed or revised one with `action_already_decided`.
         * @summary Accept Assistant Action
         * @param {AssistantConversationsApiAcceptAssistantActionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptAssistantAction(requestParameters: AssistantConversationsApiAcceptAssistantActionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateAISystemsAction> {
            return localVarFp.acceptAssistantAction(requestParameters.conversationId, requestParameters.actionId, requestParameters.createAISystemsAcceptance, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one of the user\'s conversations; refused while it is answering.
         * @summary Delete Assistant Conversation
         * @param {AssistantConversationsApiDeleteAssistantConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssistantConversation(requestParameters: AssistantConversationsApiDeleteAssistantConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAssistantConversation(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Decline what Scout proposed. A dismissed action answers as it is, an accepted or revised one with `action_already_decided`.
         * @summary Dismiss Assistant Action
         * @param {AssistantConversationsApiDismissAssistantActionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissAssistantAction(requestParameters: AssistantConversationsApiDismissAssistantActionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateAISystemsAction> {
            return localVarFp.dismissAssistantAction(requestParameters.conversationId, requestParameters.actionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Assistant Conversation
         * @param {AssistantConversationsApiGetAssistantConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssistantConversation(requestParameters: AssistantConversationsApiGetAssistantConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssistantConversation> {
            return localVarFp.getAssistantConversation(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Inputs the next question can be sent with, preselected from the last question.
         * @summary Get Assistant Conversation Turn Options
         * @param {AssistantConversationsApiGetAssistantConversationTurnOptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssistantConversationTurnOptions(requestParameters: AssistantConversationsApiGetAssistantConversationTurnOptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TurnOptions> {
            return localVarFp.getAssistantConversationTurnOptions(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Inputs a new conversation in this scope can be started with.
         * @summary Get Assistant Turn Options
         * @param {AssistantConversationsApiGetAssistantTurnOptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssistantTurnOptions(requestParameters: AssistantConversationsApiGetAssistantTurnOptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TurnOptions> {
            return localVarFp.getAssistantTurnOptions(requestParameters.scopeType, requestParameters.aiSystemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Assistant Conversation Messages
         * @param {AssistantConversationsApiListAssistantConversationMessagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssistantConversationMessages(requestParameters: AssistantConversationsApiListAssistantConversationMessagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AssistantConversationMessage>> {
            return localVarFp.listAssistantConversationMessages(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * The current user\'s conversations across scopes, most recently active first; `title` searches them.
         * @summary List Assistant Conversations
         * @param {AssistantConversationsApiListAssistantConversationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssistantConversations(requestParameters: AssistantConversationsApiListAssistantConversationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AssistantConversationPage> {
            return localVarFp.listAssistantConversations(requestParameters.page, requestParameters.size, requestParameters.scopeType, requestParameters.aiSystemId, requestParameters.title, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rename Assistant Conversation
         * @param {AssistantConversationsApiRenameAssistantConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameAssistantConversation(requestParameters: AssistantConversationsApiRenameAssistantConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssistantConversation> {
            return localVarFp.renameAssistantConversation(requestParameters.conversationId, requestParameters.renameConversationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Run the last failed question again with the inputs it was sent with.
         * @summary Retry Assistant Turn
         * @param {AssistantConversationsApiRetryAssistantTurnRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryAssistantTurn(requestParameters: AssistantConversationsApiRetryAssistantTurnRequest, options?: RawAxiosRequestConfig): AxiosPromise<TurnAccepted> {
            return localVarFp.retryAssistantTurn(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send Assistant Message
         * @param {AssistantConversationsApiSendAssistantMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAssistantMessage(requestParameters: AssistantConversationsApiSendAssistantMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<TurnAccepted> {
            return localVarFp.sendAssistantMessage(requestParameters.conversationId, requestParameters.sendMessageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a conversation in a scope together with its first question.
         * @summary Start Assistant Conversation
         * @param {AssistantConversationsApiStartAssistantConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAssistantConversation(requestParameters: AssistantConversationsApiStartAssistantConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<TurnAccepted> {
            return localVarFp.startAssistantConversation(requestParameters.startConversationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Live events of a conversation. Answers carry their message id as SSE id; reconnect with `Last-Event-ID`.
         * @summary Stream Assistant Conversation
         * @param {AssistantConversationsApiStreamAssistantConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        streamAssistantConversation(requestParameters: AssistantConversationsApiStreamAssistantConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<StreamAssistantConversation200Response> {
            return localVarFp.streamAssistantConversation(requestParameters.conversationId, requestParameters.lastEventID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for acceptAssistantAction operation in AssistantConversationsApi.
 */
export interface AssistantConversationsApiAcceptAssistantActionRequest {
    readonly conversationId: string

    readonly actionId: string

    readonly createAISystemsAcceptance: CreateAISystemsAcceptance
}

/**
 * Request parameters for deleteAssistantConversation operation in AssistantConversationsApi.
 */
export interface AssistantConversationsApiDeleteAssistantConversationRequest {
    readonly conversationId: string
}

/**
 * Request parameters for dismissAssistantAction operation in AssistantConversationsApi.
 */
export interface AssistantConversationsApiDismissAssistantActionRequest {
    readonly conversationId: string

    readonly actionId: string
}

/**
 * Request parameters for getAssistantConversation operation in AssistantConversationsApi.
 */
export interface AssistantConversationsApiGetAssistantConversationRequest {
    readonly conversationId: string
}

/**
 * Request parameters for getAssistantConversationTurnOptions operation in AssistantConversationsApi.
 */
export interface AssistantConversationsApiGetAssistantConversationTurnOptionsRequest {
    readonly conversationId: string
}

/**
 * Request parameters for getAssistantTurnOptions operation in AssistantConversationsApi.
 */
export interface AssistantConversationsApiGetAssistantTurnOptionsRequest {
    readonly scopeType: ScopeType

    readonly aiSystemId?: string | null
}

/**
 * Request parameters for listAssistantConversationMessages operation in AssistantConversationsApi.
 */
export interface AssistantConversationsApiListAssistantConversationMessagesRequest {
    readonly conversationId: string
}

/**
 * Request parameters for listAssistantConversations operation in AssistantConversationsApi.
 */
export interface AssistantConversationsApiListAssistantConversationsRequest {
    readonly page?: number

    readonly size?: number

    readonly scopeType?: ScopeType | null

    readonly aiSystemId?: string | null

    readonly title?: string | null
}

/**
 * Request parameters for renameAssistantConversation operation in AssistantConversationsApi.
 */
export interface AssistantConversationsApiRenameAssistantConversationRequest {
    readonly conversationId: string

    readonly renameConversationRequest: RenameConversationRequest
}

/**
 * Request parameters for retryAssistantTurn operation in AssistantConversationsApi.
 */
export interface AssistantConversationsApiRetryAssistantTurnRequest {
    readonly conversationId: string
}

/**
 * Request parameters for sendAssistantMessage operation in AssistantConversationsApi.
 */
export interface AssistantConversationsApiSendAssistantMessageRequest {
    readonly conversationId: string

    readonly sendMessageRequest: SendMessageRequest
}

/**
 * Request parameters for startAssistantConversation operation in AssistantConversationsApi.
 */
export interface AssistantConversationsApiStartAssistantConversationRequest {
    readonly startConversationRequest: StartConversationRequest
}

/**
 * Request parameters for streamAssistantConversation operation in AssistantConversationsApi.
 */
export interface AssistantConversationsApiStreamAssistantConversationRequest {
    readonly conversationId: string

    /**
     * Replay the answers after this message
     */
    readonly lastEventID?: string | null
}

/**
 * AssistantConversationsApi - object-oriented interface
 */
export class AssistantConversationsApi extends BaseAPI {
    /**
     * Run what Scout proposed with the chosen items, in one transaction. The first decision wins: an accepted action answers with its stored result, a dismissed or revised one with `action_already_decided`.
     * @summary Accept Assistant Action
     * @param {AssistantConversationsApiAcceptAssistantActionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public acceptAssistantAction(requestParameters: AssistantConversationsApiAcceptAssistantActionRequest, options?: RawAxiosRequestConfig) {
        return AssistantConversationsApiFp(this.configuration).acceptAssistantAction(requestParameters.conversationId, requestParameters.actionId, requestParameters.createAISystemsAcceptance, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one of the user\'s conversations; refused while it is answering.
     * @summary Delete Assistant Conversation
     * @param {AssistantConversationsApiDeleteAssistantConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAssistantConversation(requestParameters: AssistantConversationsApiDeleteAssistantConversationRequest, options?: RawAxiosRequestConfig) {
        return AssistantConversationsApiFp(this.configuration).deleteAssistantConversation(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Decline what Scout proposed. A dismissed action answers as it is, an accepted or revised one with `action_already_decided`.
     * @summary Dismiss Assistant Action
     * @param {AssistantConversationsApiDismissAssistantActionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dismissAssistantAction(requestParameters: AssistantConversationsApiDismissAssistantActionRequest, options?: RawAxiosRequestConfig) {
        return AssistantConversationsApiFp(this.configuration).dismissAssistantAction(requestParameters.conversationId, requestParameters.actionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Assistant Conversation
     * @param {AssistantConversationsApiGetAssistantConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAssistantConversation(requestParameters: AssistantConversationsApiGetAssistantConversationRequest, options?: RawAxiosRequestConfig) {
        return AssistantConversationsApiFp(this.configuration).getAssistantConversation(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inputs the next question can be sent with, preselected from the last question.
     * @summary Get Assistant Conversation Turn Options
     * @param {AssistantConversationsApiGetAssistantConversationTurnOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAssistantConversationTurnOptions(requestParameters: AssistantConversationsApiGetAssistantConversationTurnOptionsRequest, options?: RawAxiosRequestConfig) {
        return AssistantConversationsApiFp(this.configuration).getAssistantConversationTurnOptions(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inputs a new conversation in this scope can be started with.
     * @summary Get Assistant Turn Options
     * @param {AssistantConversationsApiGetAssistantTurnOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAssistantTurnOptions(requestParameters: AssistantConversationsApiGetAssistantTurnOptionsRequest, options?: RawAxiosRequestConfig) {
        return AssistantConversationsApiFp(this.configuration).getAssistantTurnOptions(requestParameters.scopeType, requestParameters.aiSystemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Assistant Conversation Messages
     * @param {AssistantConversationsApiListAssistantConversationMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAssistantConversationMessages(requestParameters: AssistantConversationsApiListAssistantConversationMessagesRequest, options?: RawAxiosRequestConfig) {
        return AssistantConversationsApiFp(this.configuration).listAssistantConversationMessages(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The current user\'s conversations across scopes, most recently active first; `title` searches them.
     * @summary List Assistant Conversations
     * @param {AssistantConversationsApiListAssistantConversationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAssistantConversations(requestParameters: AssistantConversationsApiListAssistantConversationsRequest = {}, options?: RawAxiosRequestConfig) {
        return AssistantConversationsApiFp(this.configuration).listAssistantConversations(requestParameters.page, requestParameters.size, requestParameters.scopeType, requestParameters.aiSystemId, requestParameters.title, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rename Assistant Conversation
     * @param {AssistantConversationsApiRenameAssistantConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public renameAssistantConversation(requestParameters: AssistantConversationsApiRenameAssistantConversationRequest, options?: RawAxiosRequestConfig) {
        return AssistantConversationsApiFp(this.configuration).renameAssistantConversation(requestParameters.conversationId, requestParameters.renameConversationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Run the last failed question again with the inputs it was sent with.
     * @summary Retry Assistant Turn
     * @param {AssistantConversationsApiRetryAssistantTurnRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retryAssistantTurn(requestParameters: AssistantConversationsApiRetryAssistantTurnRequest, options?: RawAxiosRequestConfig) {
        return AssistantConversationsApiFp(this.configuration).retryAssistantTurn(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send Assistant Message
     * @param {AssistantConversationsApiSendAssistantMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendAssistantMessage(requestParameters: AssistantConversationsApiSendAssistantMessageRequest, options?: RawAxiosRequestConfig) {
        return AssistantConversationsApiFp(this.configuration).sendAssistantMessage(requestParameters.conversationId, requestParameters.sendMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a conversation in a scope together with its first question.
     * @summary Start Assistant Conversation
     * @param {AssistantConversationsApiStartAssistantConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public startAssistantConversation(requestParameters: AssistantConversationsApiStartAssistantConversationRequest, options?: RawAxiosRequestConfig) {
        return AssistantConversationsApiFp(this.configuration).startAssistantConversation(requestParameters.startConversationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Live events of a conversation. Answers carry their message id as SSE id; reconnect with `Last-Event-ID`.
     * @summary Stream Assistant Conversation
     * @param {AssistantConversationsApiStreamAssistantConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public streamAssistantConversation(requestParameters: AssistantConversationsApiStreamAssistantConversationRequest, options?: RawAxiosRequestConfig) {
        return AssistantConversationsApiFp(this.configuration).streamAssistantConversation(requestParameters.conversationId, requestParameters.lastEventID, options).then((request) => request(this.axios, this.basePath));
    }
}

